import { Clock, MessageSquare, Mic, BarChart } from 'lucide-react';
import { motion } from 'framer-motion';
import { formatDuration } from '@/utils/parser';
import type { TranscriptStats } from '@/types';

interface StatsCardsProps {
  stats: TranscriptStats;
}

export function StatsCards({ stats }: StatsCardsProps) {
  const cards = [
    {
      icon: Clock,
      label: 'Total Duration',
      value: formatDuration(stats.totalDuration),
      color: 'from-sky-400 to-blue-500',
      bgColor: 'bg-sky-50 dark:bg-sky-900/20',
      iconColor: 'text-sky-600 dark:text-sky-400',
    },
    {
      icon: Mic,
      label: 'Speakers',
      value: stats.speakerStats.length.toString(),
      color: 'from-emerald-400 to-green-500',
      bgColor: 'bg-emerald-50 dark:bg-emerald-900/20',
      iconColor: 'text-emerald-600 dark:text-emerald-400',
    },
    {
      icon: MessageSquare,
      label: 'Segments',
      value: stats.segmentCount.toString(),
      color: 'from-violet-400 to-purple-500',
      bgColor: 'bg-violet-50 dark:bg-violet-900/20',
      iconColor: 'text-violet-600 dark:text-violet-400',
    },
    {
      icon: BarChart,
      label: 'Total Words',
      value: stats.wordCount.toLocaleString(),
      color: 'from-amber-400 to-orange-500',
      bgColor: 'bg-amber-50 dark:bg-amber-900/20',
      iconColor: 'text-amber-600 dark:text-amber-400',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <motion.div
          key={card.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="stats-card"
        >
          <div className="flex items-start justify-between">
            <div className={`p-2.5 rounded-xl ${card.bgColor}`}>
              <card.icon className={`w-5 h-5 ${card.iconColor}`} />
            </div>
          </div>
          <div className="mt-4">
            <p className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white">
              {card.value}
            </p>
            <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">
              {card.label}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
